import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TribunaleaAuthProvider } from "@tribunalea/auth/react";
import { RouterProvider, ToastProvider } from "@tribunalea/ui";
import App from "./App.jsx";
import "@tribunalea/ui/styles.css";
import "./styles.css";

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const liveContent = (
  <RouterProvider>
    <App authEnabled />
  </RouterProvider>
);
const demoContent = (
  <RouterProvider>
    <App authEnabled={false} />
  </RouterProvider>
);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ToastProvider>
      <TribunaleaAuthProvider
        publishableKey={clerkPublishableKey}
        demoFallback={demoContent}
      >
        {liveContent}
      </TribunaleaAuthProvider>
    </ToastProvider>
  </StrictMode>,
);
